import React from 'react';
import Basepage, { BasePageState } from '../Basepage';
import guaranteeLabelDE from './images/gewaehrleistungslabel-de.jpg';
import './index.scss';

interface LegalGuaranteeNoticePageState extends BasePageState {}

export default class LegalGuaranteeNoticePage extends Basepage<
  LegalGuaranteeNoticePageState,
  {}
> {
  initState(base: BasePageState): LegalGuaranteeNoticePageState {
    return {
      ...base,
    };
  }

  getApiReqestUrl(): string {
    return this.state.apiBase + this.state.apiData.apiRequestUri;
  }

  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(_prevProp: any, _prevState: any): void {}

  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }
  pageHeaderGetter(): string {
    return '';
  }
  pageTitleGetter(): string {
    return 'Gesetzliche Gewährleistungsrechte';
  }
  getBreadCrumb(): JSX.Element {
    return <span></span>;
  }
  getType(): string {
    return 'LegalGuaranteeNoticePage';
  }

  renderChild(): JSX.Element {
    return (
      <div id="legalGuaranteeNoticePage">
        <h1>Ihre gesetzlichen Gewährleistungsrechte</h1>
        <p>
          Für Waren, die wir innerhalb der Europäischen Union verkaufen,
          gelten mindestens zwei Jahre gesetzliche Gewährleistung der
          Vertragsmäßigkeit. Diese Rechte bestehen unabhängig von etwaigen
          Herstellergarantien.
        </p>
        <div id="legalGuaranteeNotice">
          <a
            href="https://europa.eu/youreurope/garantien"
            target="_blank"
            rel="noopener noreferrer"
            title="Gesetzliche Gewährleistung - weitere Informationen auf europa.eu"
          >
            <img
              src={guaranteeLabelDE}
              alt="Gesetzliche Gewährleistung: Mindestens zwei Jahre gesetzliche Gewährleistung der Vertragsmäßigkeit für Waren, die in der Europäischen Union verkauft werden. Weitere Informationen unter europa.eu/youreurope/garantien."
            />
          </a>
        </div>
      </div>
    );
  }
}
